import { Blockquote } from '../Blockquote/Blockquote';

export function BlockquoteBranded({
  text,
  children,
}: {
  text?: string;
  children?: React.ReactNode;
}) {
  return (
    <Blockquote className="border-l-4 border-primary bg-primary/15 text-primary">
      {children ?? text}
    </Blockquote>
  );
}
